import { DimensionInput } from '@src/common/components/DimensionInput';
import { css } from '@src/common/styles/Styles';
import clsx from 'clsx';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props<T extends FieldValues> {
  control: Control<T>;
  fieldName: Path<T>;
  label?: string;
  name?: string;
  disabled?: boolean;
  displayUnits?: boolean;
  ariaLabel?: string;
  className?: string;
  tabIndex?: number;
}

export const FormDimensionInput = <T extends FieldValues>({
  control,
  fieldName,
  label,
  disabled,
  name,
  ariaLabel,
  displayUnits,
  className,
  tabIndex,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      render={({
        field,
        fieldState: { error },
        formState: { disabled: formDisabled },
      }) => (
        <DimensionInput
          {...field}
          tabIndex={tabIndex}
          readOnly={disabled || formDisabled}
          className={className ? clsx(fullWidth, className) : fullWidth}
          label={label ?? t(`fields.${fieldName}`)}
          error={error && t(`formErrors.${error!.message}`)}
          displayUnits={displayUnits}
          ariaLabel={ariaLabel}
        />
      )}
      name={(name ?? fieldName) as Path<T>}
    />
  );
};
const fullWidth = css({
  flex: 1,
});
